import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import media from '../../utils/style'
import { Flex, Heading, Text } from 'rebass'

import typography from '../../utils/typography'

/*************************
 STYLES: VehicleListingHeader
 **************************/

const Header = styled(Flex)`
  flex-direction: column;
  gap: 20px;
  margin-top: ${typography.rhythm(0.5)};
  ${media.LargeScreenUp`
    margin-top: ${typography.rhythm(1.5)};
  `};
`

class VehicleListingHeader extends React.PureComponent {
  render() {
    return (
      <Header mx={['5%', '10%', '5%', '10%']}>
        <Heading fontSize={[5, 6, 7]}>{this.props.title}</Heading>
        <Text lineHeight={1.5}>{this.props.description}</Text>
      </Header>
    )
  }
}

VehicleListingHeader.propTypes = {
  title: string,
  description: string
}

export default VehicleListingHeader
